import logo from "./logo.svg";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import Login from "./Containers/Login/Login";
import LoginLayoutRoute from "./Containers/LayoutRouting/LoginLayoutRoute";
import {
  Routes,
  Route,
  useNavigate,
} from "react-router-dom";
import AdminDashboard from "./Containers/AdminDashboard/AdminDashboard";
import LayoutRoute from "./Containers/LayoutRouting/LayoutRoute";
import { ThemeProvider, createTheme } from "@mui/material";
import Register from "./Containers/Register/Register";
import AdminProcessorDashboard from "../src/Containers/AdminProcessorDashboard/AdminProcessorDashboard";
import Fields from "../src/Containers/Fields/Fields";
import IssueCertificate from "../src/Containers/IssueCertificate/IssueCertificate";
import processorDashboard from "./Containers/ProcessorDashboard/processorDashboard";
import ProcessorDashboard from "./Containers/ProcessorDashboard/processorDashboard";
import DDreport from "./Containers/DDReport/DDreport";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ResetPassword from "./Containers/Login/resetPassword";
import ErrorPage from "./Components/custom_404";
import CacheBuster from "./CacheBuster";
import { Button } from "react-bootstrap";
const theme = createTheme({
  palette: {
    primary: {
      main: "#048c88",
      light: "#064e4a",
      dark: "#064e4a",
    },
    secondary: {
      main: "#49ae46",
      light: "#d5f2f0",
      dark: "#2e9a2b",
    },
  },
  props: {
    MuiButton: {
      size: "medium",
    },
    MuiFilledInput: {},
    MuiFormControl: {},
    MuiFormHelperText: {},
    MuiIconButton: {
      size: "medium",
    },
    MuiInputBase: {},
    MuiInputLabel: {},
    MuiListItem: {
      dense: true,
    },
    MuiOutlinedInput: {},
    MuiFab: {
      size: "medium",
    },
    MuiTable: {
      size: "medium",
    },
    MuiTextField: {
      variant: "filled",
      size: "medium",
    },
    MuiToolbar: {
      variant: "dense",
    },
  },

  overrides: {},
});

const userRole = localStorage.getItem("userrole");
function App() {
  return (
    <CacheBuster>
      {({ loading, isLatestVersion, refreshCacheAndReload }) => {
        if (loading) return null;
        
        // if (!isLatestVersion) {
        //   refreshCacheAndReload(); // Redirect to the login page when a new version is detected
        //   return null; // Prevent rendering after redirection
        // }



       
        return (

          <div className="App">
            <ThemeProvider theme={theme}>
              <ToastContainer autoClose={2000} />
              <Routes>
                <Route path="/" element={<LoginLayoutRoute component={Login} />} />
                <Route path="/register" element={<LoginLayoutRoute component={Register} />} />
                <Route path="/resetPassword" element={<LoginLayoutRoute component={ResetPassword} />} />
                {userRole === "Admin" && (
                  <>
                <Route path="/admin/dashboard" element={<LayoutRoute component={AdminDashboard} />} />
                <Route path="/admin/processordashboard" element={<LayoutRoute component={AdminProcessorDashboard} />} />
                <Route path="/admin/fields" element={<LayoutRoute component={Fields} />} />
                <Route path="/admin/issuecertificate" element={<LayoutRoute component={IssueCertificate} />} />

                  </>
                )}
                {userRole === "Processor" && (
                  <>
                <Route path="/processor/dashboard" element={<LayoutRoute component={ProcessorDashboard} />} />
                <Route path="/processor/ddreport" element={<LayoutRoute component={DDreport} />} />
                {/* <Route path="*" element={<LayoutRoute component={ErrorPage} />} /> */}
                </>
                )}
                <Route path="*" element={<LayoutRoute component={ErrorPage} />} />
              </Routes>
            </ThemeProvider>
          </div>
        );
      }}
    </CacheBuster>
  );
}

export default App;
